import clsx from "clsx";
import { UseFormRegisterReturn } from "react-hook-form";

import { FieldWrapperPassThroughProps } from "@/types/common";

import { FieldWrapper } from "./FieldWrapper";
import { PropsWithChildren } from "react";

type InputFieldProps = FieldWrapperPassThroughProps & {
  className?: string;
  defaultChecked?: boolean;
  registration: Partial<UseFormRegisterReturn>;
};

export const Checkbox = ({
  label,
  className,
  defaultChecked,
  registration,
  error,
  children,
}: PropsWithChildren<InputFieldProps>) => {
  return (
    <FieldWrapper error={error} className="flex items-center">
      <div className="flex">
        <input
          type="checkbox"
          defaultChecked={defaultChecked}
          className={clsx(
            "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600",
            className
          )}
          {...registration}
        />
        {label && (
          <label className="ms-2 text-sm flex items-center font-medium text-gray-900 dark:text-gray-300">
            {label}
          </label>
        )}
        {children}
      </div>
    </FieldWrapper>
  );
};
